function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

async function trigger_sentry_error(error_message, error_stack) {
  const csrftoken = getCookie('csrftoken');
  await fetch(`${window.location.origin}/capture-error/`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken,
    },
    body: JSON.stringify({
      error: error_message,
      error_stack: error_stack,
    }),
  });
}
async function fetchGoldAndSilverPrices() {
  try {
    const url = `${window._Torus.BFF_BASE_URL}/product/rates`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch gold and silver prices');
    }

    const data = await response.json();

    if (data.success && data.result) {
      const goldPrice = data.result.gBuy;
      const silverPrice = data.result.sBuy;

      document.getElementById('gold-price').textContent =
        `${goldPrice.toFixed(2)} /gm`;
      document.getElementById('silver-price').textContent =
        `${silverPrice.toFixed(2)} /gm`;
    } else {
      throw new Error('Failed to retrieve valid data from API');
    }
  } catch (error) {
    trigger_sentry_error(
      'There was an error fetching gold and silver prices',
      error.stack,
    );
  }
}

document.addEventListener('DOMContentLoaded', fetchGoldAndSilverPrices);

document.getElementById('refresh-icon').addEventListener('click', () => {
  fetchGoldAndSilverPrices();
});
